module.exports = __webpack_public_path__ + "07_mustache_brown.6895d7b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/07_mustache_brown.png
// module id = lzgI
// module chunks = 0